import React from "react";
import Watermark from "components/Watermark";
import * as utils from "common/utils";
import { HashLink as Link } from "react-router-hash-link";

const FarmCrops = (props) => {
    const { budget, refData } = props;
    const { blocks = [] } = budget;
    const productiveBlocks = blocks.filter((block) => block.isProductive) || [];
    const nonProductiveBlocks = blocks.filter((block) => !block.isProductive) || [];

    const BlockRow = ({ block }) => {
        const blockIcon = utils.getBlockIcon(block.type);
        const blockType = utils.getBlockTypeText(refData, block, false);
        const latestResults = block.currentResults ? block.currentResults : {};
        const nSurplus = !latestResults.nitrogenOverview || latestResults.nitrogenOverview.surplus === undefined ? "X" : latestResults.nitrogenOverview.surplus;
        const nLost = !latestResults.nitrogenOverview || latestResults.nitrogenOverview.lostToWater === undefined ? "X" : latestResults.nitrogenOverview.lostToWater;
        const pLost = !latestResults.phosphorusOverview || latestResults.phosphorusOverview.lostToWater === undefined ? "X" : latestResults.phosphorusOverview.lostToWater;
        const totalNLost = !latestResults.nitrogenOverview || latestResults.nitrogenOverview.totalLost === undefined ? "X" : latestResults.nitrogenOverview.totalLost;
        const totalPLost = !latestResults.phosphorusOverview || latestResults.phosphorusOverview.totalLost === undefined ? "X" : latestResults.phosphorusOverview.totalLost;
        const nDrainage = !latestResults.nitrogenOverview || latestResults.nitrogenOverview.drainage === undefined || latestResults.nitrogenOverview.drainage.isNaN ? "X" : latestResults.nitrogenOverview.drainage;
        const analysisTotalNLost = budget.currentResults && budget.currentResults.nitrogenOverview && budget.currentResults.nitrogenOverview.farmTotalLoss;

        return (
            <tr>
                <td>
                    <div className="u-flex">
                        <img className="u-icon-sm u-mr-sm" src={blockIcon} alt="Block Type" />
                        <div className="u-pt-sm">
                            <Link to={`#${block.id}`}>{block.name}</Link>
                        </div>
                    </div>
                </td>
                <td>{blockType}</td>
                <td className="u-textRight">{(block.type === "FodderCrop" ? block.rotationArea : block.areaInHectares).toLocaleString()}</td>
                <td className="u-textRight">{totalNLost.toLocaleString()}</td>
                <td className="u-textRight">{nLost}</td>
                <td className="u-textRight">{nDrainage}</td>
                <td className="u-textRight">{nSurplus}</td>
                <td className="u-textRight">{totalPLost.toLocaleString()}</td>
                <td className="u-textRight">{pLost}</td>
                <td className="u-textRight">{block.type === "FodderCrop" ? "-" : utils.round((block.areaInHectares / budget.totalBlockAreaInHectares) * 100, 0)}</td>
                <td className="u-textRight">{analysisTotalNLost ? utils.round((totalNLost / analysisTotalNLost) * 100, 0) : "-"}</td>
            </tr>
        );
    };

    const OtherRow = ({ analysis }) => {
        const otherNLoss = analysis.currentResults && analysis.currentResults.nitrogenOverview && analysis.currentResults.nitrogenOverview.otherSources;
        const otherPLoss = analysis.currentResults && analysis.currentResults.phosphorusOverview && analysis.currentResults.phosphorusOverview.otherSources;
        const icon = utils.getBlockIcon("other");

        return (
            <tr>
                <td>
                    <div className="u-flex">
                        <img className="u-icon-sm u-mr-sm" src={icon} alt="Other sources" />
                        <div className="u-pt-sm">Other sources</div>
                    </div>
                </td>
                <td>Other</td>
                <td className="u-textRight">-</td>
                <td className="u-textRight">{otherNLoss}</td>
                <td className="u-textRight">-</td>
                <td className="u-textRight">-</td>
                <td className="u-textRight">-</td>
                <td className="u-textRight">{otherPLoss}</td>
                <td className="u-textRight">-</td>
                <td className="u-textRight">-</td>
                <td className="u-textRight">-</td>
            </tr>
        );
    };

    return (
        <div className="Table Table-Compressed">
            <Watermark />
            <table>
                <thead>
                    <tr>
                        <th data-width="30">Name</th>
                        <th>Type</th>
                        <th>Area (ha)</th>
                        <th>N loss</th>
                        <th>N loss/ha</th>
                        <th>N in drainage (ppm)</th>
                        <th>N surplus/ha</th>
                        <th>P loss</th>
                        <th>P loss/ha</th>
                        <th>Blocked area %</th>
                        <th>N farm loss %</th>
                    </tr>
                </thead>
                <tbody>
                    {refData &&
                        refData.blockTypes &&
                        refData.blockTypes.map((blockType) => {
                            const blocksByType = productiveBlocks.filter((block) => block.type === blockType.value);
                            return blocksByType.length > 0 && blocksByType.map((block) => <BlockRow key={block.id} block={block} />);
                        })}
                </tbody>
                <tbody>
                    {nonProductiveBlocks.length > 0 && nonProductiveBlocks.map((block) => <BlockRow key={block.id} block={block} />)}
                    <OtherRow key="other.sources.results" analysis={budget} />
                </tbody>
            </table>
        </div>
    );
};

export default FarmCrops;
